import NumberFormat from 'react-number-format';
import Input2 from './input-2/Input2';
import { Controller } from 'react-hook-form';

const InputWithFormat = ({
    format = null,
    type,
    mask = '',
    onChange,
    prefix = '',
    defaultValue = '',
    ...props
}) => (<Input2
    {...props}
    inputCreator={(inputProps, control) => {
        if (props.fieldName && control) {
            return <Controller
                name={props.fieldName}
                control={control}
                rules={inputProps.rules}
                render={({ field: { onChange, onBlur, name, value, ref } }) => (
                    <NumberFormat
                        {...inputProps}
                        onValueChange={({ value }) =>
                            onChange && onChange(value ? `${prefix}${value}` : '')
                        }
                        defaultValue={`${value}`.replace(prefix, '')}
                        format={format}
                        mask={mask}
                        prefix={prefix}
                        thousandSeparator={' '}
                        type={type === 'number' ? 'tel' : type}
                        name={name}
                        onBlur={onBlur}
                        ref={ref}
                    />
                )}
            />
        }
        return (
            <NumberFormat
                {...inputProps}
                onValueChange={({ value, formattedValue }) =>
                    onChange && onChange({ value: `${value && prefix}${value}`, formattedValue })
                }
                defaultValue={`${defaultValue}`.replace(prefix, '')}
                format={format}
                mask={mask}
                prefix={prefix}
                thousandSeparator={' '}
                type={type === 'number' ? 'tel' : type}
            />
        )
    }}
/>)
export default InputWithFormat;
